module.exports = __webpack_public_path__ + "static/media/4@2x.70ff7cbb.png";